export function redirectToCreateOrganization(props) {
  props?.router?.push('/organizations/add');
}
